import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
      multi: true
    }
  ]
})
export class InputComponent implements ControlValueAccessor {
  @Input()
  public control: FormControl;
  @Input()
  public type: string;
  @Input()
  public label: string;
  @Input()
  public placeholder: string;
  @Input()
  public disabled: boolean;
  @Input()
  public readonly: boolean;
  @Input()
  public isInvalid: boolean;
  @Input()
  public isPassword = false;
  @Input()
  public isServerError = false;
  @Input()
  public height: string;
  @Input()
  public value: string;
  @Input()
  public required: boolean;

  constructor() {}

  public get inputHeight(): string {
    return this.height || '50px';
  }

  public set innerValue(value) {
    value = value.trim();
    if (value !== undefined && this.value !== value) {
      this.value = value;
      this.onChange(value);
      this.onTouch(value);
    }
  }
  public get innerValue(): string {
    return this.value;
  }

  public writeValue(value: string): void {
    this.value = value;
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  private onChange: any = () => {};
  private onTouch: any = () => {};

  public changeType(): void {
    if (this.type === 'password') {
      this.type = 'text';
    } else {
      this.type = 'password';
    }
  }
}
